export function filterWithoutAccents(options, search, label = 'nome') {
  const normalize = (str: string) =>
    str
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()

  const optionsFiltered = options.filter((option: any) => {
    return normalize(option?.[label]).includes(normalize(search))
  })

  return optionsFiltered
}
